import { Link } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';
import { Spinner } from 'flowbite-react';

/**
 *
 * @param { string } className
 * @param { string } buttonClassName
 * @param { string } to
 * @param { string } type
 * @param { boolean } waiting
 *
 * @returns Base Button
 */
export default function Button(props) {
  const { className, buttonClassName, defaultCSS, to, type, children, waiting, ...otherProps } =
    props;

  return (
    <div
      className={twMerge(
        'flex h-7 w-fit items-center justify-center bg-blue-400 hover:bg-blue-500',
        className,
      )}
    >
      {waiting ? (
        <div className={twMerge('w-full cursor-wait pb-1 text-center', buttonClassName)}>
          <Spinner size="sm" className="fill-blue-700 text-white" />
        </div>
      ) : null}

      {type === 'link' ? (
        <Link
          to={to}
          {...otherProps}
          className={twMerge('text-lg font-medium text-white', buttonClassName)}
        >
          {children}
        </Link>
      ) : null}

      {type === 'button' && !waiting ? (
        <button
          type="button"
          {...otherProps}
          className={twMerge('text-lg font-medium text-white', buttonClassName)}
        >
          {children}
        </button>
      ) : null}

      {type === 'submit' && !waiting ? (
        <button
          type="submit"
          {...otherProps}
          className={twMerge('text-lg font-medium text-white', buttonClassName)}
        >
          {children}
        </button>
      ) : null}
    </div>
  );
}
